import {useState} from "react";
import {
    Button,
    ButtonProps
} from "@mantine/core";
import {ProvisionPipelineDrawer} from "../drawers/ProvisionPipelineDrawer.tsx";
import {AiOutlineRocket} from "react-icons/ai";

export const ProvisionPipelineButton = (props: ButtonProps) => {

    const [drawerOpened, setDrawerOpened] = useState(false);

    if (drawerOpened) {
        return (
            <ProvisionPipelineDrawer
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        );
    } else {
        return (
            <Button
                leftSection={<AiOutlineRocket/>}
                onClick={() => {
                    setDrawerOpened(true);
                }}
                {...props}
            >Provision Pipeline</Button>
        );
    }
};
